module.exports = __webpack_public_path__ + "static/img/16ok.e667d46c.webp";